import { axiosClient } from '../network/appClient';
import { AppliedCouponResponseDTO } from '../DTO/checkoutResponseDTO';

export const getDiscountCoupon = async (code: string): Promise<{
    coupon?: AppliedCouponResponseDTO;
    error?: string;
}> => {
    try {
        const response = await axiosClient.get('Sale/DiscountCoupon', {
            params: { Code: code },
            validateStatus: () => true,
        });

        if (response.status === 200) {
            const raw = response.data as unknown;
            const rawObj = (raw && typeof raw === 'object') ? (raw as Record<string, unknown>) : {};
            const discountValueRaw = (rawObj?.discountValue ?? rawObj?.value ?? 0);
            const discountValueNum = Number(discountValueRaw);
            const percentageRaw = rawObj?.percentage;
            const percentageNum = Number(percentageRaw);
            const applyToWaveLevelRaw = rawObj?.applyToWaveLevel;
            const applyToWaveLevelNum = Number(applyToWaveLevelRaw);
            const couponData: AppliedCouponResponseDTO = {
                id: (rawObj?.id ?? rawObj?.discountCouponId ?? rawObj?.discountId) as number | undefined,
                value: (rawObj?.code ?? rawObj?.value ?? '') as string,
                discountValue: Number.isFinite(discountValueNum)
                    ? discountValueNum
                    : 0,
                percentage: Number.isFinite(percentageNum) ? percentageNum : undefined,
                applyToWaveLevel: Number.isFinite(applyToWaveLevelNum) && applyToWaveLevelNum > 0 ? applyToWaveLevelNum : undefined,
            };
            return { coupon: couponData }; 
        }

        const rawError = response.data as unknown;
        const errorObj = (rawError && typeof rawError === 'object') ? (rawError as Record<string, unknown>) : {};
        const backendMessage =
            (errorObj?.message as string | undefined) ||
            (errorObj?.parameter as string | undefined) ||
            (errorObj?.Parameter as string | undefined);

        const normalizedMessage = (() => {
            if (backendMessage === 'DiscountCoupon.UnauthorizedUse') {
                return 'Cupom não pode ser usado neste contexto';
            }
            if (backendMessage === 'DiscountCoupon.Unavailable') {
                return 'Cupom indisponível para uso';
            }
            return backendMessage;
        })();

        if (response.status === 404) {
            return { error: normalizedMessage || 'Cupom não encontrado' };
        }

        if (response.status === 401) {
            return { error: 'Cupom requer autenticação. Faça login para aplicar.' };
        }

        if (response.status === 400) {
            return {
                error: normalizedMessage || 'Cupom inválido ou expirado',
            };
        }

        const errorMsg =
            normalizedMessage || `Erro ${response.status}: ${response.statusText}`;
        return { error: errorMsg };
    } catch (error) {
        return { error: 'Erro na requisição de cupom' };
    }
};
